import api from '../../utils/backend-api'
import apiCommunity from '@/utils/backend/community.js'
import { Community } from '../../models/Community'

// import { get } from 'lodash'

const state = {
  community: new Community(),
  items: []
}

const getters = {}

const actions = {
  async getAllCommunities ({ commit }, { archivedIncluded = false } = {}) {
    let communities = await apiCommunity.getAllCommunities(archivedIncluded);
    await commit('setItems', communities);
  },
  getCommunityById ({ commit }, id) {
    commit('setLoading', { loading: true })
    if (id) {
      api.getData('/community/' + id).then(
        res => {
          const community = res.data
          commit('setCommunity', community)
          commit('breadcrumbs/replace',
            {
              find: ':community',
              replace: { text: community.name },
            },
            { root: true },
          )
        },
        // err => {
        //   console.log(err)
        // },
      )
    } else {
      commit('setCommunity', new Community())
    }
  },
}

const mutations = {
  setOrderList (state, orders) {
    state.orders = orders
  },
  setItems (state, communities) {
    state.items = communities
  },
  setCommunity (state, community) {
    state.community = community
  },
  replaceBreadcrumb (state, payload, rootState) {
    rootState.breadcrumbs.breadcrumbs = payload
  },
  setPagination (state, pagination) {
    state.pagination = pagination
  },
  setLoading (state, { loading }) {
    state.loading = loading
  },
  setNotice (state, { notice }) {
    state.notice = notice
  },
  setSnackbar (state, { snackbar }) {
    state.snackbar = snackbar
  },
  setMode (state, { mode }) {
    state.mode = mode
  },
  setCustomer (state, { customer }) {
    state.customer = customer
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
